<template>
  <div id="content">
    <section id="user">
      <div class="input_list">
        <ul>
          <li>
            <span>
              <label class="list_key">{{label.email}}</label>
              <label class="important">必須</label>
            </span>
            <input type="text" class="list_box" v-model.trim="accountForm.email" placeholder="****@domans.co.jp" v-bind:disabled="!isEdit" maxlength="128"/>
            <label v-if="errors.email" class="error_text">{{errors.email}}</label>
          </li>
        </ul>
      </div>
    </section>
    <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'

export default {
  name: 'AccountInput',
  components: {
  },
  props: {
    isEdit: Boolean,
    accountForm: Object
  },
  data () {
    return {
      errors: {},
      label: {
        email: 'メールアドレス'
      }
    }
  },
  computed: {
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }

      return true
    },
    validateRequire: function () {
      if (!this.accountForm.email) {
        this.errors['email'] = this.label.email + 'は必須項目です。'
      }
    },
    validateFormat: function () {
      if (!Check.isMail(this.accountForm.email)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
    },
    setErrorMessage: function (errors) {
      this.errors = Object.assign({}, errors)
    }
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/AccountInput.vue